import { render } from "./XsInfo.vue?vue&type=template&id=a5a0746c"
import script from "./XsInfo.vue?vue&type=script&lang=js"
export * from "./XsInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__